import BaseService from '@/services/base_service';
import { clearPhone } from '@/services/string';
import Axios from 'axios';

export default class CategoryService extends BaseService {

  async list(params) {
    try {
      return await axios.get('/categorias', params);
    } catch (e) {
      throw e;
    }
  }
  async get(id) {
    try {
      return await axios.get('/categorias/' + id);
    } catch (e) {
      throw e;
    }
  }
  async create(model) {

    try {
      return await axios.post('categorias/', model);
    } catch (e) {
      throw this.getErrors(e);
    }
  }

  async update(model, id) {
    try {
      return await axios.put('/categorias/' + id, model);
    } catch (e) {
      throw this.getErrors(e);
    }
  }

  async delete(id) {
    try {
      return await axios.delete('/categorias/' + id);
    } catch (e) {
      throw e;
    }
  }


}



// WEBPACK FOOTER //
// ./src/services/category.js